var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-play-badge",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162,
    height: 48,
    viewBox: "0 0 162 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.112,
    y1: 1.238,
    x2: -0.075,
    y2: 1.238,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a89c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#298ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00abe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#31b4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4fb9dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58bbdb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.178,
    y1: 2.838,
    x2: -2.083,
    y2: 2.838,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffac00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#f88f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.394,
    y1: 1.145,
    x2: -0.347,
    y2: 1.145,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e72a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba0c56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.399,
    y1: 1.77,
    x2: -0.351,
    y2: 1.77,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38915e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#38995e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#54aa51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#63ae4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#66af4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bb04f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6cb14f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    fill: "#000203",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 48,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161,
    height: 47,
    rx: 9.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M73.555,22.692a5.1,5.1,0,1,0,5.123,5.1,5.031,5.031,0,0,0-5.123-5.1m0,8.2A2.953,2.953,0,0,1,70.674,27.8a2.888,2.888,0,1,1,5.761,0,2.952,2.952,0,0,1-2.88,3.092m-11.177-8.2A5.1,5.1,0,1,0,67.5,27.8a5.031,5.031,0,0,0-5.124-5.1m0,8.2A2.952,2.952,0,0,1,59.5,27.8a2.888,2.888,0,1,1,5.761,0,2.953,2.953,0,0,1-2.881,3.092M49.084,24.258v2.166h5.18a4.519,4.519,0,0,1-1.178,2.725,5.3,5.3,0,0,1-4,1.585,5.761,5.761,0,0,1,0-11.521,5.519,5.519,0,0,1,3.9,1.546l1.528-1.526a7.554,7.554,0,0,0-5.432-2.185,7.927,7.927,0,1,0,0,15.853,7.247,7.247,0,0,0,5.528-2.224,7.156,7.156,0,0,0,1.876-5.065,7.017,7.017,0,0,0-.116-1.354Zm54.37,1.682a4.743,4.743,0,0,0-4.369-3.248,4.85,4.85,0,0,0-4.813,5.1,4.994,4.994,0,0,0,5.064,5.1,5.076,5.076,0,0,0,4.254-2.262l-1.74-1.16a2.916,2.916,0,0,1-2.514,1.411,2.6,2.6,0,0,1-2.474-1.547l6.824-2.822Zm-6.96,1.7a2.8,2.8,0,0,1,2.668-2.977,1.974,1.974,0,0,1,1.895,1.082Zm-5.549,4.949h2.243v-15H90.945Zm-3.673-8.758H87.2a3.538,3.538,0,0,0-2.687-1.141,5.109,5.109,0,0,0,0,10.208A3.477,3.477,0,0,0,87.2,31.74h.077v.734c0,1.954-1.043,3-2.725,3a2.824,2.824,0,0,1-2.572-1.817l-1.952.812a4.865,4.865,0,0,0,4.524,3.016c2.629,0,4.853-1.547,4.853-5.316V23H87.272ZM84.7,30.889a2.928,2.928,0,0,1-2.842-3.073A2.951,2.951,0,0,1,84.7,24.7a2.875,2.875,0,0,1,2.725,3.113A2.851,2.851,0,0,1,84.7,30.889m29.257-13.3h-5.365v15h2.238V26.907h3.127a4.666,4.666,0,1,0,0-9.318m.058,7.23h-3.185V19.676h3.185a2.572,2.572,0,1,1,0,5.143m13.838-2.154a4.206,4.206,0,0,0-4,2.3l1.988.83a2.121,2.121,0,0,1,2.046-1.1,2.156,2.156,0,0,1,2.354,1.93v.155a4.957,4.957,0,0,0-2.335-.578c-2.142,0-4.324,1.177-4.324,3.377a3.465,3.465,0,0,0,3.725,3.3,3.159,3.159,0,0,0,2.857-1.466h.077v1.158h2.161V26.814c0-2.663-1.987-4.148-4.554-4.148m-.27,8.221c-.734,0-1.757-.367-1.757-1.274,0-1.158,1.273-1.6,2.374-1.6a3.982,3.982,0,0,1,2.046.5,2.714,2.714,0,0,1-2.663,2.374m12.7-7.894-2.567,6.5h-.077l-2.664-6.5h-2.412l3.995,9.09-2.278,5.057h2.335l6.157-14.147Zm-20.168,9.6h2.239v-15h-2.239Z",
    transform: "translate(8.208 3.409)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M10.529,7.553a2.4,2.4,0,0,0-.556,1.686V35.778a2.4,2.4,0,0,0,.556,1.685l.088.088L25.484,22.683v-.352L10.616,7.465Z",
    transform: "translate(1.995 1.493)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M22.9,20.68v.352l4.955,4.958.113-.064,5.872-3.336c1.678-.954,1.678-2.514,0-3.467l-5.872-3.336-.112-.064Z",
    transform: "translate(4.58 3.145)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M10.436,34.955a1.951,1.951,0,0,0,2.494.074l17.53-9.96L25.392,20Z",
    transform: "translate(2.087 4)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M10.436,7.618,25.392,22.573,30.459,17.5,12.93,7.544a2.756,2.756,0,0,0-1.345-.4,1.532,1.532,0,0,0-1.148.478",
    transform: "translate(2.087 1.428)",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M23.226,6.791c0-1.726.968-2.822,2.49-2.822,1.5,0,2.412,1.027,2.412,2.724v.373H24.311v.059a1.431,1.431,0,0,0,1.441,1.549,1.3,1.3,0,0,0,1.285-.656h1.026a2.194,2.194,0,0,1-2.342,1.564C24.174,9.582,23.226,8.519,23.226,6.791Zm1.085-.514h2.73a1.3,1.3,0,0,0-1.329-1.4A1.384,1.384,0,0,0,24.311,6.277Zm16.014.514c0-1.726.968-2.823,2.492-2.823,1.5,0,2.41,1.027,2.41,2.724v.373H41.412v.059A1.427,1.427,0,0,0,42.85,8.672a1.3,1.3,0,0,0,1.286-.656h1.026a2.193,2.193,0,0,1-2.342,1.564C41.273,9.581,40.325,8.518,40.325,6.791Zm1.087-.515H44.14a1.3,1.3,0,0,0-1.33-1.4A1.382,1.382,0,0,0,41.412,6.276ZM5.955,7.949c0-.972.724-1.534,2.01-1.614l1.462-.084V5.784c0-.571-.377-.892-1.1-.892-.595,0-1.008.218-1.126.6H6.164c.109-.928.982-1.523,2.209-1.523,1.354,0,2.118.675,2.118,1.815V9.477H9.464V8.718H9.379a1.819,1.819,0,0,1-1.623.848A1.632,1.632,0,0,1,5.955,7.949Zm2.154-.829c-.744.05-1.081.3-1.081.78s.421.769,1,.769a1.273,1.273,0,0,0,1.4-1.181V7.035Zm24.758.928V4.995h-.857V4.1h.857V2.727h1.067V4.1h1.172v.9H33.934V7.774c0,.566.233.814.765.814a3.459,3.459,0,0,0,.407-.026v.89a3.648,3.648,0,0,1-.581.054C33.338,9.506,32.866,9.088,32.866,8.047ZM50.182,9.476V6.246c0-.869-.378-1.3-1.166-1.3a1.239,1.239,0,0,0-1.291,1.368V9.476H46.659v-5.4h1.026V4.93h.08a1.619,1.619,0,0,1,1.613-.962,1.758,1.758,0,0,1,1.87,2.01v3.5Zm-13.669,0v-5.4h1.026V4.9h.081a1.465,1.465,0,0,1,1.459-.918,2.368,2.368,0,0,1,.475.044V5.079a2.915,2.915,0,0,0-.6-.064,1.265,1.265,0,0,0-1.379,1.27v3.19Zm-17.135,0-1.951-5.4h1.141l1.345,4.263H20l1.339-4.263h1.132l-1.945,5.4Zm-7.2,0v-5.4h1.063v5.4Zm-9.927,0V3.327H0V2.316H5.613V3.327H3.365V9.476ZM8.124,2.942c.322-.1.551-.318.551-.531s-.214-.377-.516-.377a1.329,1.329,0,0,0-.556.1v-.68a2.1,2.1,0,0,1,.705-.115c.71,0,1.17.377,1.17.973A1.3,1.3,0,0,1,8.53,3.468Zm35.561.391-.831-1.086h-.078l-.829,1.086h-1.1l1.39-1.717H43.4l1.385,1.717Zm-17.111,0-.819-1.011h-.079l-.819,1.011H23.747l1.389-1.642H26.3l1.39,1.642ZM12.02,2.475a.691.691,0,1,1,.69.649A.656.656,0,0,1,12.02,2.475Zm15.016-.918L25.93,0h1.111l.948,1.557Z",
    transform: "translate(49.25 5.628)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(11.966 8.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M30.348,24.132l-17.418,9.9a2,2,0,0,1-2.4.013l-.089.09.089.086h0a2,2,0,0,0,2.4-.013l17.53-9.96Z",
    transform: "translate(-9.879 -3.742)",
    fill: "#020100",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M10.528,32.6a2.4,2.4,0,0,1-.556-1.686v.175a2.4,2.4,0,0,0,.556,1.686l.089-.089Z",
    transform: "translate(-9.972 -2.386)",
    fill: "#020100",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M33.012,21.558l-5.983,3.4.112.112,5.872-3.336A2.1,2.1,0,0,0,34.27,20a2.234,2.234,0,0,1-1.258,1.556",
    transform: "translate(-6.561 -4.568)",
    fill: "#020100",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M13.021,7.72l23.4,13.3a2.235,2.235,0,0,1,1.259,1.558,2.107,2.107,0,0,0-1.259-1.733l-23.4-13.3C11.344,6.592,9.972,7.382,9.972,9.3v.175c0-1.92,1.372-2.712,3.049-1.759",
    transform: "translate(-9.972 -7.14)",
    fill: "#fff",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.ae4bf812252a2f6b96d3ee061cccbbc0.svg";
export { ForwardRef as ReactComponent };